var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "VueCarousel-slide",
      class: {
        "VueCarousel-slide-active": _vm.isActive,
        "VueCarousel-slide-center": _vm.isCenter,
        "VueCarousel-slide-adjustableHeight": _vm.isAdjustableHeight
      },
      attrs: { tabindex: "-1", "aria-hidden": !_vm.isActive, role: "tabpanel" }
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ecd28db6", { render: render, staticRenderFns: staticRenderFns })
  }
}